import React, { useCallback, useEffect, useRef } from 'react'
import fetch from 'lib/decorated-fetch'
import Router from 'next/router'
import { logger, metrics } from 'lib/slardar-utils'
import ImageStyles from 'Components/view-image/style'
import getUrl from 'lib/url'
import { sendTeaCommEvent } from 'lib/tea-analyze'
import { useCityName } from 'Components/hooks'
import { getSearchLink } from 'New/search/utils'
import { handleAsPath } from 'lib/utils'
import decodeUriComponent from 'decode-uri-component'
import xss from 'xss'
import classNames from 'classnames'

interface IBuriedPointInfo {
  motor_id?: string
  series_id?: string
}

interface IResult {
  keyword: string
  image_url?: string
  cpl_type?: number
  buried_point_info?: IBuriedPointInfo
}
interface IListProps {
  data: IResult[]
  value: string
  cityName: string | undefined
  setList: (list: any) => void
  type: string
  keyword: string
  inputeValue?: string
}
interface IState {
  data: IResult[]
  show: boolean
  type: string
}

const handler = (
  spanKeyword: string,
  searchMode = 'common',
  value: string,
  cityName: string | undefined,
  query_input_text?: string
) => {
  // 去除高亮插入标签
  const keyword = spanKeyword?.replace(/<[^>]+>/g, '')
  if (searchMode === 'sug') {
    sendTeaCommEvent('clk_event', {
      event_id: 'common_search_recommend',
      query_content: keyword,
      query_input_text,
    })
  } else if (searchMode === 'common' || searchMode === 'preset') {
    sendTeaCommEvent('clk_event', {
      event_id: 'common_search_btn',
      query_content: keyword,
      query_input_text,
    })
  } else if (searchMode === 'history') {
    sendTeaCommEvent('clk_event', {
      event_id: 'common_search_history',
      query_content: keyword,
      query_input_text,
    })
  }
  sessionStorage.setItem('search_content', keyword)
  sessionStorage.setItem('search_mode', searchMode)
  saveLocalSearch(keyword)
  const link = getSearchLink({
    keyword,
    city_name: cityName || '',
    from: 'DELETE_KEY',
    api_param: 'DELETE_KEY',
    search_mode: searchMode,
  })
  // 非搜索页面的话新开页面跳转
  if (window?.location?.pathname?.indexOf('/search') === 0) {
    // 如果aspath 没改变的话需要强制刷新页面 不然 右侧组件 show 有问题
    if (
      decodeUriComponent(`/search${window.location.search}`) ===
      decodeUriComponent(link.as || '')
    ) {
      window.location.href = link.as
      return
    }
    Router.push(link.link, link.as)
    // window.location.href = link.as
    return
  }
  window.open(link.as, '_blank')
}

function ResultList({
  data,
  value,
  cityName,
  setList,
  type = '',
  inputeValue = '',
}: IListProps) {
  //考虑高亮关键字
  if (inputeValue && data?.length) {
    /* eslint-disable no-unused-expressions */
    data?.forEach((item: any) => {
      if (item?.keyword && item?.keyword?.indexOf('<span>') === -1) {
        item.keyword = item?.keyword?.replace(
          inputeValue,
          `<span>${inputeValue}</span>`
        )
      }
    })
  }
  return (
    <ul className="result new-search-list-wrap">
      {type && data?.length ? (
        <li className="local-history">
          历史搜索
          <span
            className="local-btn fr"
            onClick={() => {
              clearLocalSearch()
              setList({ type: '', data: [], show: false })
              sendTeaCommEvent('clk_event', {
                event_id: 'common_search_clear',
              })
            }}
          >
            清空
          </span>
        </li>
      ) : (
        ''
      )}
      {data?.map?.((item: IResult, index: number) => {
        if (item.keyword && item.keyword?.trim()) {
          return (
            <li
              key={`${item.keyword}-${index}`}
              className={classNames({
                keyword: true,
              })}
              onClick={(e: React.MouseEvent<HTMLLIElement, MouseEvent>) => {
                e.stopPropagation()
                handler(
                  item.keyword,
                  type || 'sug',
                  value,
                  cityName,
                  inputeValue
                )
              }}
            >
              {item?.image_url && item?.cpl_type === 2 ? (
                <img className="logo" src={item?.image_url} alt="" />
              ) : (
                ''
              )}
              <p
                className="text g-one-line-text"
                // eslint-disable-next-line react/no-danger
                dangerouslySetInnerHTML={{
                  __html: xss.filterXSS(item.keyword),
                }}
              />
              {item?.buried_point_info?.series_id ? (
                <a
                  className="search-series search-more-info"
                  target="_blank"
                  href={`/auto/series/${item?.buried_point_info?.series_id}`}
                  onClick={(e) => {
                    e.stopPropagation()
                    sendTeaCommEvent('clk_event', {
                      event_id: 'common_search_tag',
                      query_content: item.keyword?.replace(/<[^>]+>/g, ''),
                      query_input_text: inputeValue,
                      tag_name: '车系直达',
                    })
                  }}
                >
                  车系直达
                </a>
              ) : (
                ''
              )}
              {item?.buried_point_info?.motor_id ? (
                <a
                  className="search-community search-more-info"
                  target="_blank"
                  href={`/community/${item?.buried_point_info?.motor_id}`}
                  onClick={(e) => {
                    e.stopPropagation()
                    sendTeaCommEvent('clk_event', {
                      event_id: 'common_search_tag',
                      query_content: item.keyword?.replace(/<[^>]+>/g, ''),
                      query_input_text: inputeValue,
                      tag_name: '车友圈',
                    })
                  }}
                >
                  车友圈
                </a>
              ) : (
                ''
              )}
            </li>
          )
        }
        return ''
      })}
      <style jsx>
        {`
          .search-more-info {
            float: right;
            font-size: 14px;
            color: #979aa8;
          }
          .search-community {
            margin-right: 24px;
          }
          .search-more-info:after {
            content: '';
            width: 0;
            height: 0;
            top: -1px;
            display: inline-block;
            border-top: 4px solid transparent;
            border-bottom: 4px solid transparent;
            border-left: 5px solid #979aa8;
            margin-left: 6px;
          }
          .keyword:hover .search-more-info {
            color: #1f2129;
          }
          .keyword:hover .search-more-info:after {
            border-left: 5px solid #1f2129;
          }
          ul.result .active .search-more-info {
            color: #1f2129;
          }
          ul.result .active .search-more-info:after {
            border-left: 5px solid #1f2129;
          }

          .result {
            position: absolute;
            top: 40px;
            left: 0;
            right: 0;
            z-index: 1000;
            background: #fff;
            margin-top: 4px;
            box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.2);
            width: 100%;
          }
          .keyword {
            line-height: 33px;
            height: 33px;
            padding: 0 16px;
            font-size: 16px;
            cursor: pointer;
            color: #1f2129;
          }
          .logo {
            display: inline-block;
            width: 28px;
            height: 28px;
            margin-right: 4px;
            vertical-align: middle;
          }
          :global(.new-search-list-wrap .keyword .text) {
            display: inline-block;
            vertical-align: middle;
            max-width: 100%;
          }
          :global(.new-search-list-wrap .keyword span) {
            color: #ac5252;
          }
          .local-history {
            line-height: 40px;
            height: 40px;
            padding: 0 16px;
            font-size: 14px;
            color: #1f2129;
            font-weight: 500;
          }
          .local-btn {
            font-size: 14px;
            font-weight: normal;
            cursor: pointer;
          }
          .local-btn:hover {
            color: #ac5252;
          }
          .local-btn:before {
            background-image: url(${require('static/search-local-clear.png')});
            background-size: contain;
            background-position: center;
            width: 13px;
            height: 13px;
            display: inline-block;
            margin-bottom: -2px;
            margin-right: 2px;
            content: '';
          }
          .local-btn:hover:before {
            background-image: url(${require('static/search-local-clear-hover.png')});
            background-size: contain;
            background-position: center;
          }
          .keyword:hover {
            background: rgba(255, 204, 50, 0.3);
          }
          ul.result .active {
            background: rgba(255, 204, 50, 0.3);
          }
        `}
      </style>
    </ul>
  )
}

const fetchRollInfo = async () => {
  try {
    const json = await fetch(getUrl(`/motor/searchpage/launcher/main/v1/`))
    return json?.data?.hot_search_roll_info?.map((item: any) => item.default)
  } catch (error) {
    return []
  }
}

const DEFUALT_PLACEHOLDER = ''

interface IProps {
  isFixed?: boolean
  className?: string
}

export default function Search(props: IProps) {
  const cityName = useCityName()
  const [focus, setFocus] = React.useState(false)
  const [value, setValue] = React.useState('')

  /* 列表数据 */
  const [list, setList] = React.useState<IState>({
    show: true,
    data: [],
    type: '',
  })

  const isShowListRef = useRef<boolean>(false)

  const searchDivRef = useRef<HTMLDivElement>(null)
  const buttonRef = useRef<HTMLButtonElement>(null)
  const inputRef = useRef<HTMLInputElement>(null)

  // 搜索预置词 index 间隔3s
  const rollIndex = useRef<number>(0)
  const rollList = useRef<string[]>()

  const setRollInfo = useCallback(() => {
    // 用户focus时 或者 无预置词 直接返回
    if (focus || !rollList?.current?.length || !inputRef?.current) {
      return
    }
    // 搜索页面保留用户的输入
    if (window?.location?.pathname?.indexOf('/search') === 0) {
      if (inputRef?.current?.value === '') {
        inputRef.current.placeholder = rollList?.current?.[rollIndex?.current]
        rollIndex.current++
        if (rollIndex.current >= rollList?.current?.length) {
          rollIndex.current = 0
        }
      }
      return
    }
    // 非搜索页面 非focus时 用户有输入也清空
    inputRef.current.value = ''
    setValue('')
    inputRef.current.placeholder = rollList?.current?.[rollIndex?.current]
    rollIndex.current++
    if (rollIndex.current >= rollList?.current?.length) {
      rollIndex.current = 0
    }
  }, [focus])

  useEffect(() => {
    const init = async () => {
      const list = await fetchRollInfo()
      rollList.current = list
      setRollInfo()
    }
    init()
  }, [])

  useEffect(() => {
    const rollTimer = window.setInterval(() => {
      setRollInfo()
    }, 3000)
    return () => {
      window.clearInterval(rollTimer)
    }
  }, [setRollInfo])

  const href = typeof window === 'undefined' ? '' : window?.location?.href
  const keyword = handleAsPath(href)?.keyword
  useEffect(() => {
    // 搜索页面才处理
    if (window?.location?.pathname?.indexOf('/search') === 0) {
      setValue(keyword)
      saveLocalSearch(keyword)
      setList((preValue) => {
        return { type: '', data: preValue.data, show: false }
      })
    }
  }, [keyword])

  useEffect(() => {
    const searchDivDom = searchDivRef.current
    const searchButtonDom = buttonRef.current
    const onMouseEnter = () => {
      if (searchDivDom) searchDivDom.classList.add('button-hover')
    }
    const onMouseLeave = () => {
      if (searchDivDom) searchDivDom.classList.remove('button-hover')
    }
    if (searchDivDom && searchButtonDom) {
      searchButtonDom.addEventListener('mouseenter', onMouseEnter)
      searchButtonDom.addEventListener('mouseleave', onMouseLeave)
    }

    return () => {
      if (searchDivDom && searchButtonDom) {
        searchButtonDom.removeEventListener('mouseenter', onMouseEnter)
        searchButtonDom.removeEventListener('mouseleave', onMouseLeave)
      }
    }
  }, [searchDivRef.current, buttonRef.current])

  const fetchComlete = (value: any) => {
    fetch(
      getUrl(`/motor/searchacl/complete?motor_source=pc_new&keyword=${value}`)
    ).then((json) => {
      if (inputRef?.current?.value === '') {
        return
      }
      setList({
        show: true,
        type: '',
        data: json?.data?.filter((t: any) => t?.keyword !== 'undefined'),
      })
    })
  }

  useEffect(() => {
    if (!value || handleAsPath(window?.location?.href)?.keyword === value) {
      return
    }
    fetchComlete(inputRef?.current?.value)
  }, [value])

  const searchBtnHandler = () => {
    let searchType = 'common'
    isShowListRef.current = false
    let searchValue = inputRef?.current?.value?.trim() || ''
    if (
      inputRef?.current?.placeholder &&
      (searchValue === undefined || searchValue === '')
    ) {
      searchType = 'preset'
      searchValue = inputRef?.current?.placeholder as string
    }
    handler(
      searchValue?.trim(),
      searchType,
      searchValue?.trim(),
      cityName,
      inputRef?.current?.value || ''
    )
  }

  // 顶部菜单吸屏的时候 需要收起下拉框
  const { isFixed = false, className } = props
  useEffect(() => {
    if (isFixed) {
      setList((preValue) => {
        return { ...preValue, show: false }
      })
      setFocus(false)
      inputRef?.current?.blur?.()
    }
  }, [isFixed])

  return (
    <div
      className={classNames(
        'tw-relative tw-flex tw-h-32 lg:tw-h-40 xl:tw-h-44 tw-m-auto tw-w-354 md:tw-w-444 lg:tw-w-574 xl:tw-w-569 2xl:tw-w-664 tw-rounded-2',
        className
      )}
      ref={searchDivRef}
    >
      <input
        ref={inputRef}
        type="text"
        className="search-form tw-leading-14 tw-outline-none tw-text-common-black tw-appearance-none tw-bg-white tw-flex-auto tw-px-16 tw-border-2 tw-border-r-0 tw-border-solid tw-border-common-yellow tw-rounded-bl-2 tw-rounded-tl-2 tw-text-12 xl:tw-text-14"
        placeholder={DEFUALT_PLACEHOLDER}
        value={value}
        onChange={(e) => {
          isShowListRef.current = true
          setValue(e?.target?.value)
          if (e?.target?.value === '') {
            setList({ data: getLocalSearch(), show: true, type: 'history' })
          } else {
            setList((preValue) => {
              return { type: '', data: preValue.data, show: false }
            })
          }
        }}
        onBlur={() => {
          setFocus(false)
          setTimeout(() => {
            setList({ ...list, show: false, type: '' })
          }, 200)
        }}
        onFocus={(e) => {
          isShowListRef.current = true
          // focus 搜索框被点击但未输出任何内容状态
          // 页面切换 value为undefined 但是 e.target.value 有可能任会有值
          if (e?.target?.value === '') {
            setList({ data: getLocalSearch(), show: true, type: 'history' })
          } else {
            if (list?.data?.length) {
              setList({ ...list, show: true, type: '' })
            } else {
              fetchComlete(e?.target?.value)
            }
          }
          setFocus(true)
          sendTeaCommEvent('clk_event', {
            event_id: 'common_search_input',
          })
        }}
        onKeyDownCapture={(e) => {
          if (e.keyCode === 13) {
            e?.currentTarget?.blur()
            searchBtnHandler()
            setFocus(false)
            setTimeout(() => {
              setList({ ...list, show: false, type: '' })
            }, 200)
          }
        }}
      />
      <button
        ref={buttonRef}
        type="submit"
        className="tw-w-64 tw-bg-common-yellow tw-font-medium tw-text-common-black tw-rounded-br-2 tw-rounded-tr-2"
        onClick={(e) => {
          e.stopPropagation()
          searchBtnHandler()
        }}
      >
        搜索
      </button>
      {list.show && isShowListRef?.current ? (
        <ResultList
          keyword={value}
          data={list.data}
          value={value}
          cityName={cityName}
          setList={setList}
          type={list.type}
          inputeValue={inputRef?.current?.value || ''}
        />
      ) : (
        ''
      )}
    </div>
  )
}

function getLocalSearch() {
  if (typeof window === 'undefined') {
    return []
  }
  try {
    const list = window.localStorage.getItem('search_local_list') || '[]'
    return JSON.parse(list)?.map((value: string) => {
      return { keyword: value }
    })
  } catch (err: any) {
    metrics.counter('localStorage.getItem', { key: 'search_local_list' })
    logger.warn(
      `[search_local_list] Error get window.localStorage.getItem, err: ${err?.message}`
    )
    return []
  }
}

function clearLocalSearch() {
  if (typeof window === 'undefined') {
    return
  }
  try {
    window.localStorage.setItem('search_local_list', '')
  } catch (err: any) {
    console.error(err)
    metrics.counter('localStorage.setItem', { key: 'search_local_list' })
    logger.warn(
      `[search_local_list] Error clear window.localStorage.setItem, err: ${err?.message}`
    )
  }
}

function saveLocalSearch(value: string) {
  if (typeof window === 'undefined' || value === undefined) {
    return
  }
  try {
    const storageList = JSON.parse(
      window.localStorage.getItem('search_local_list') || '[]'
    )
    // 首先去重
    const index = storageList.indexOf(value)
    if (index > -1) {
      storageList.splice(index, 1)
    }
    // 最多8条记录
    const maxList = storageList.slice(0, 7)
    window.localStorage.setItem(
      'search_local_list',
      JSON.stringify([value, ...maxList])
    )
  } catch (err: any) {
    console.error(err)
    metrics.counter('localStorage.setItem', { key: 'search_local_list' })
    logger.warn(
      `[search_local_list] Error set window.localStorage.setItem, err: ${err?.message}`
    )
  }
}
